import React from "react";
import { Box, FormControl, FormControlLabel, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSound } from "../../../../../../context/juno/SoundContext";

// インストゥルメンタル/ボーカル選択コントロール
const InstrumentalControl: React.FC = () => {
  const { t } = useTranslation();
  const { instrumental, setInstrumental } = useSound();

  // インストゥルメンタル設定を切り替え
  const handleInstrumentalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInstrumental(event.target.checked);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch checked={instrumental} onChange={handleInstrumentalChange} name="instrumental" color="primary" />
          }
          label={t("juno.sound.params.instrumentalMode")}
        />
      </FormControl>
    </Box>
  );
};

export default InstrumentalControl;
